var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgType2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 19",
    style: {
      enableBackground: "new 0 0 22 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6D6E71;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,18.4c-5.7,0-10.3-4.6-10.3-10.3c0-2.8,1.2-5.6,3.2-7.5l0.1-0.1h13.7l0.1,0.1C19.8,2.6,21,5.3,21,8.1 C21,13.8,16.4,18.4,10.8,18.4z M4.3,1.5C2.5,3.2,1.5,5.6,1.5,8.1c0,5.1,4.2,9.3,9.3,9.3c5.1,0,9.3-4.2,9.3-9.3c0-2.5-1-4.9-2.8-6.6 H4.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,16c-1.5,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6c1.5,0,2.6,1.2,2.6,2.6S9.4,16,7.9,16z M7.9,11.7 c-0.9,0-1.6,0.7-1.6,1.6C6.3,14.3,7,15,7.9,15c0.9,0,1.6-0.7,1.6-1.6C9.6,12.5,8.8,11.7,7.9,11.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,16c-1.5,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6c1.5,0,2.6,1.2,2.6,2.6S15.2,16,13.8,16z M13.8,11.7 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6C15.4,12.5,14.7,11.7,13.8,11.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,11c-1.5,0-2.6-1.2-2.6-2.6c0-1.5,1.2-2.6,2.6-2.6c1.5,0,2.6,1.2,2.6,2.6C7.5,9.8,6.4,11,4.9,11z M4.9,6.7 C4,6.7,3.3,7.4,3.3,8.3C3.3,9.2,4,10,4.9,10c0.9,0,1.6-0.7,1.6-1.6C6.5,7.4,5.8,6.7,4.9,6.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,11c-1.5,0-2.6-1.2-2.6-2.6c0-1.5,1.2-2.6,2.6-2.6c1.5,0,2.6,1.2,2.6,2.6C19.5,9.8,18.3,11,16.8,11z  M16.8,6.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C18.5,7.4,17.7,6.7,16.8,6.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,11c-1.5,0-2.6-1.2-2.6-2.6c0-1.5,1.2-2.6,2.6-2.6c1.5,0,2.6,1.2,2.6,2.6C13.5,9.8,12.3,11,10.9,11z  M10.9,6.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C12.5,7.4,11.8,6.7,10.9,6.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,5.3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S14.5,5.3,13.7,5.3z M13.7,2.9 c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C14.5,3.3,14.1,2.9,13.7,2.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,5.3c-0.8,0-1.5-0.7-1.5-1.5S7.2,2.2,8,2.2s1.5,0.7,1.5,1.5S8.9,5.3,8,5.3z M8,2.9c-0.5,0-0.8,0.4-0.8,0.8 c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C8.8,3.3,8.5,2.9,8,2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2);
export default __webpack_public_path__ + "static/media/Type2.1eead4a62782f9f4275c230e5f1aa134.svg";
export { ForwardRef as ReactComponent };